module.exports = __webpack_public_path__ + "static/media/10_crisalide.dacef7fd.jpg";